import AnchorTextGenerator from '../../../src/components/content-ai-tools/AnchorTextGenerator';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={AnchorTextGenerator} />;
};

export default PublicDiscoveryKeywordsWrapped;
